import React from 'react';
import { Button } from '@workspace/ui/common/Buttons/Button';
import { ContactSupportButton } from '../contact-support.types';
import { getButtonVariant } from '../lib/contact-support.utils';
import { stripInvisibles } from '@workspace/constants';

interface ContactSupportButtonsProps {
  buttons?: Array<ContactSupportButton & React.ComponentProps<typeof Button>>;
}

export function ContactSupportButtons({ buttons }: ContactSupportButtonsProps) {
  if (!buttons?.length) return null;

  return (
    <div className="flex flex-col md:flex-row gap-sm w-full">
      {buttons.map((btn, index) => {
        const variant = getButtonVariant(btn);
        const content = typeof btn.children === 'string' ? stripInvisibles(btn.children).trim() : btn.children;

        return (
          <Button
            key={index}
            variant={variant}
            url={btn.href}
            openInNewTab={btn.target === '_blank'}
            className="leading-5 w-full md:w-auto justify-center"
          >
            {content}
          </Button>
        );
      })}
    </div>
  );
}
